import common from './common.json';
import dashboard from './dashboard.json';
import employees from './employees.json';
import specialties from './specialties.json';
import questions from './questions.json';
import instructions from './instructions.json';
import testing from './testing.json';
import results from './results.json';
import activityReport from './activityReport.json';
import medical from './medical.json';
import profile from './profile.json';
import errors from './errors.json';
import wheelMeasurements from './wheelMeasurements.json';
import locomotives from './locomotives.json';

const translation = {
  common,
  dashboard,
  employees,
  specialties,
  questions,
  instructions,
  testing,
  results,
  activityReport,
  medical,
  profile,
  errors,
  wheelMeasurements,
  locomotives,
};

export default translation;
